import PropTypes from "prop-types"
import React from "react"

import { withTranslation } from "../../../../i18n/translate"
import ArrowDownIcon from "../../../../images/icons/arrow_down.svg"
import ClearFilterIcon from "../../../../images/icons/clear.svg"
import Button from "../../../button/button"
import Info from "../../../info/info"
import BooleanProductFilter from "./boolean-product-filter"
import DualNumberProductFilter from "./dual-number-product-filter"
import EffectProductFilter from "./effect-product-filter"
import EnumProductFilter from "./enum-product-filter"
import NumberProductFilter from "./number-product-filter"
import "./product-filter.sass"
import RangeProductFilter from "./range-product-filter"

const classNames = require("classnames")

class ProductFilter extends React.Component {
  constructor(props) {
    super(props)
    this.filterContentRef = React.createRef()
    this.state = {
      ssr: true,
      hidden: true,
      hiddenByParent: true,
      collapsed: true,
      isActive: false,
    }
  }

  componentDidMount() {
    this.setState({
      ssr: false,
      hidden: this.props.productFilter.isHidden(),
      hiddenByParent: this.props.productFilter.isHiddenByParent(),
      height: this.filterContentRef.current.clientHeight,
      collapsed:
        !this.props.productFilter._isActive &&
        !this.props.productFilter.initialShown,
      isActive: this.props.productFilter.isActive(),
    })
  }

  componentDidUpdate() {
    const height = this.filterContentRef.current.clientHeight
    const newState = {}
    if (this.state.height !== height) {
      newState.height = height
    }

    const active = this.props.productFilter.isActive()
    if (this.state.isActive !== active) {
      newState.isActive = active
      if (active) {
        newState.collapsed = false
      }
    }

    const hidden = this.props.productFilter.isHidden()
    if (this.state.hidden !== hidden) {
      newState.hidden = hidden
    }

    const hiddenByParent = this.props.productFilter.isHiddenByParent()
    if (this.state.hiddenByParent !== hiddenByParent) {
      newState.hiddenByParent = hiddenByParent
      if (!hiddenByParent && !this.state.ssr) {
        newState.collapsed = false
      }
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState)
    }
  }

  render() {
    const { productFilter, reset, t } = this.props
    const { collapsed, isActive, height, hidden } = this.state

    return (
      <div
        className={classNames("_fp-filter-group", {
          "_fp-filter-group--hidden": hidden,
        })}
      >
        <div className="_fp-filter-group__header">
          <button
            className={classNames("_fp-filter-group__header__button")}
            onClick={() => this.setState({ collapsed: !collapsed })}
          >
            <div
              className={classNames("_fp-filter-group__header__button__icon", {
                "_fp-filter-group__header__button__icon--collapsed": collapsed,
              })}
            >
              <ArrowDownIcon />
            </div>
            <p className="_fp-heading-5 _fp-filter-group__header__button__label">
              {productFilter.type === "EFFECT"
                ? t("PRODUCTS-PRODUCT_FILTERS-EFFECT_COLON")
                : ""}
              {productFilter.name ? t(productFilter.name.key) : ""}
            </p>
          </button>

          {productFilter.info && (
            <Info
              customClassName={"_fp-filter-group__header__info"}
              label={t(productFilter.info.key)}
            />
          )}
        </div>

        <div
          className={classNames("_fp-filter-group__content", {
            "_fp-filter-group__content--collapsed": collapsed,
          })}
          style={{ height: height ? height + "px" : "auto" }}
        >
          <div
            className="_fp-filter-group__content__container"
            ref={this.filterContentRef}
          >
            <Button
              buttonCallback={() => reset()}
              buttonSize={"small"}
              buttonSvgIconComponent={<ClearFilterIcon />}
              buttonStyle={isActive ? "blue-soft" : "disabled"}
              buttonLabel={t("PRODUCTS-PRODUCT_FILTERS-RESET_FILTER")}
            />
            {productFilter.type === "ENUM" && (
              <EnumProductFilter productFilter={productFilter} />
            )}
            {productFilter.type === "EFFECT" && (
              <EffectProductFilter productFilter={productFilter} />
            )}
            {productFilter.type === "NUMBER" && (
              <NumberProductFilter productFilter={productFilter} />
            )}
            {productFilter.type === "RANGE" && (
              <RangeProductFilter productFilter={productFilter} />
            )}
            {productFilter.type === "DUAL_NUMBER" && (
              <DualNumberProductFilter productFilter={productFilter} />
            )}
            {productFilter.type === "BOOLEAN" && (
              <BooleanProductFilter productFilter={productFilter} />
            )}
          </div>
        </div>
      </div>
    )
  }
}

ProductFilter.propTypes = {
  productFilter: PropTypes.object.isRequired,
}

export default withTranslation()(ProductFilter)
